import { lazy } from 'react';

export const Gems = lazy(() => import('./Gems.component'));
